import * as types from '../actions'
import { RESET_ERRORS } from '../actions'
import { ADD_NOTIFICATION } from '../actions/notificationActions'

const initialState = {
  currentUser: {},
  currentUserIsLoading: true,
  settings: {},
  isLoading: true,
  settingsIsLoading: true,
  capabilities: null,
  capabilitiesIsLoading: true,
  errors: [],
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_USER_PROFILE_BEGIN:
      return {
        ...state,
        currentUser: {},
        currentUserIsLoading: true,
        isLoading: true,
      }
    case types.GET_USER_PROFILE_SUCCESS:
      return setIsLoading({
        ...state,
        currentUser: action.payload,
        currentUserIsLoading: false,
      })
    case types.GET_USER_PROFILE_FAILURE:
      return setIsLoading({
        ...state,
        errors: state.errors.concat(action.error),
        currentUserIsLoading: false,
      })
    case types.GET_SETTINGS_BEGIN:
      return {
        ...state,
        settings: null,
        settingsIsLoading: true,
        isLoading: true,
      }
    case types.GET_SETTINGS_SUCCESS:
      return setIsLoading({
        ...state,
        settings: action.settings,
        settingsIsLoading: false,
      })
    case types.GET_SETTINGS_FAILURE:
      return setIsLoading({
        ...state,
        settings: {},
        settingsIsLoading: false,
        errors: state.errors.concat(action.error),
      })
    case types.GET_CAPABILITIES_BEGIN:
      return {
        ...state,
        capabilitiesIsLoading: true,
        isLoading: true,
      }
    case types.GET_CAPABILITIES_SUCCESS:
      return setIsLoading({
        ...state,
        capabilities: action.capabilities,
        capabilitiesIsLoading: false,
      })
    case types.GET_CAPABILITIES_FAILURE:
      return setIsLoading({
        ...state,
        errors: state.errors.concat(action.error),
        capabilitiesIsLoading: false,
      })
    case ADD_NOTIFICATION:
      // Update unread count if we have a user
      if (state.currentUser && !state.currentUserIsLoading) {
        return {
          ...state,
          currentUser: {
            ...state.currentUser,
            unreadNotificationsCount: (state.currentUser.unreadNotificationsCount || 0) + 1,
          },
        }
      }
      return state

    case RESET_ERRORS:
      return {
        ...state,
        errors: [],
        isLoading: true,
        currentUserIsLoading: true,
        settingsIsLoading: true,
        capabilitiesIsLoading: true,
      }
    default:
      return state
  }
}

function setIsLoading(state) {
  return {
    ...state,
    isLoading: state.settingsIsLoading || state.currentUserIsLoading || state.capabilitiesIsLoading,
  }
}
